import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { agent } from "../../utils/agent";
import * as menteesRequestAction from "../../actions/menteesRequestAction";
import * as baseActions from "../../actions/baseActions";
import { Container, Form, Col, Button, Accordion, Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as API from "../../utils/apiPath";
import { useNavigate } from "react-router-dom";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const AddDiagnostics = (props) => {

  const { title, actions, menteeRequestData, userInfo } = props;
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [getLoader, setGetLoader] = useState(false);
  const [getShareLoader, setGetShareLoader] = useState(false);
  const [activeId, setActiveId] = useState(["1", "2"]); // default open first 2
  const [objQuestions, setObjQuestions] = useState([]);
  const [checkDiagnosticToolkit, setCheckDiagnosticToolkit] = useState({
    is_save: 0,
    is_save_share: 0,
    is_update: 0,
  });
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const submit_state = {
    button: 1,
  };

  const total_mentor = menteeRequestData?.length ?? 0;

  useEffect(() => {
    document.title = title;
    const getObjQuestionsData = () => {
      agent
        .get(API.GET_OBJ_QUEST + "/" + userInfo.id, {})
        .then((res) => {
          setObjQuestions(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    };
    getObjQuestionsData();

    const checkRequest = { user_id: userInfo.id };

    const getCheckDiagnosticToolkit = () => {
      agent
        .post(API.CHECK_DIAGNOSTIC, checkRequest)
        .then((res) => {
          setCheckDiagnosticToolkit(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    };
    getCheckDiagnosticToolkit();
  }, [title, actions, userInfo]);

  const history = useNavigate();

  const onDiagnoSubmit = (data) => {
    data.mentee_id = userInfo.id;
    if (submit_state.button === 1) {
      data.action = "save";
      setGetLoader(true);
    }
    if (submit_state.button === 2) {
      data.action = "save_share";
      setGetShareLoader(true);
    }
    if (submit_state.button === 3) {
      data.action = "update_share";
      setGetShareLoader(true);
    }

    agent
      .post(API.SET_OBJ_QUEST, data)
      .then((res1) => {
        const message = res1?.data?.message || "Record has been updated successfully.";
        if (res1.data.data === true) {
          setGetLoader(false);
          setGetShareLoader(false);
          setPopupMessage(message);
          setShowPopup(true);
          history("/my-diagnostic-toolkit");
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
        if (res1.data.data === false) {
          setPopupMessage(message);
          setShowPopup(true);
          setGetLoader(false);
          setGetShareLoader(false);
        }
      })
      .catch((err) => {
        setPopupMessage(err?.message);
        setShowPopup(true);
        setGetLoader(false);
      });
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onDiagnoSubmit)}>
        <Container>
          <div className="faqouter">
            <div className="mb-2 mb-md-4 d-flex flex-wrap" key={total_mentor}>
              <div className="mentro_details_sidebar" style={{ width: "100%" }}>
                <div className="row py-2 py-md-12">
                  <Col xl={12}>
                    <div className="d-flex">
                      <div style={{ width: "100%" }}>
                        <Accordion activeKey={activeId}>
                          {objQuestions.map((item, key) => (
                            <Card key={key + 1}>
                              <Card.Header>
                                <Button
                                  className={
                                    !activeId?.includes(String(key + 1)) &&
                                    "faq_open"
                                  }
                                  onClick={() =>
                                    setActiveId(
                                      activeId?.includes(String(key + 1))
                                        ? activeId?.filter(
                                          (id) =>
                                            id !== String(key + 1)
                                        )
                                        : [...activeId, String(key + 1)]
                                    )
                                  }
                                >
                                  <span style={{
                                    fontWeight: 600,
                                    fontSize: '1.25rem',
                                  }}>{item.ques}</span>
                                </Button>
                              </Card.Header>

                              <Accordion.Collapse eventKey={String(key + 1)}>
                                <Card.Body>
                                  {item.ques_desc && (
                                    <div className="mb-3">
                                      <i>
                                        <sup style={{ fontSize: '0.9rem', color: '#666' }}>{item.ques_desc}</sup>
                                      </i>
                                    </div>
                                  )}
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    className={
                                      errors?.answer?.[key]
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    style={{
                                      width: "100%",
                                      resize: "vertical",
                                      minHeight: "100px"
                                    }}
                                    name={`answer.${key}`}
                                    id={`answer.${key}`}
                                    aria-invalid={
                                      errors?.answer?.[key]
                                        ? "true"
                                        : "false"
                                    }
                                    placeholder="Enter your answer here..."
                                    defaultValue={item?.answer || ""}
                                    {...register(`answer.${key}`, {
                                      maxLength: 600,
                                    })}
                                  />
                                    {errors?.answer?.[key]?.type ===
                                    "required" && (
                                      <div className="invalid-feedback d-block">
                                        Please enter an answer
                                      </div>
                                    )}
                                    {errors?.answer?.[key]?.type ===
                                    "maxLength" && (
                                      <div className="invalid-feedback d-block">
                                        Answer should not exceed 600 characters
                                      </div>
                                    )}
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          ))}
                        </Accordion>

                        <div
                          className="mt-3 mt-md-3 mt-lg-4"
                          style={{ textAlign: "center" }}
                        >
                          <Button
                            type="submit"
                            className="btn loginsubmit outline me-2"
                            onClick={() => (submit_state.button = 1)}
                            disabled={getLoader}
                          >
                            {getLoader ? "Saving..." : "SAVE"}
                          </Button>

                          {checkDiagnosticToolkit.is_active_relationship ===
                            1 && (
                              <Button
                                type="submit"
                                className="btn loginsubmit outline me-2 ml-2"
                                onClick={() => (submit_state.button = 2)}
                                disabled={getShareLoader}
                              >
                                {getShareLoader
                                  ? "Sharing..."
                                  : "SAVE AND SHARE WITH YOUR MENTOR"}
                              </Button>
                            )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Form>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

AddDiagnostics.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    fetchMenteesRequest: PropTypes.func.isRequired,
  }).isRequired,
  menteeRequestData: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    menteeRequestData: state.menteeRequestData,
    userInfo: state.userInfo,
    isAuth: state.isAuth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...menteesRequestAction, ...baseActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddDiagnostics);
